import RouterUtils from '../../../../../shared/routing/RouterUtils';
import { ApiEndpoints } from '../../../../../shared/webservices/endpoint';
import MachineState from '../../../../../shared/model/MachineState';

export class MachineUpdateRequest {

    // MachineContractorSave {
    //   id: number
    //   contractor_id: number
    //   document_schema_id: number
    // }

    _id; // number
    _brand; // string
    _model; // string
    _companyId; // number
    _description; // string
    _contractors; // MachineContractorSave[]
    _licencePlate; // string
    _machineTypeId; // number
    _machineStateId; // number

    constructor(values, machine) {
        this._id = machine.id();
        this._brand = values.brand;
        this._model = values.model;
        this._companyId = values.outsource[0] ? values.outsource[0].value : undefined;
        this._description = values.description;
        this._contractors = this._parseContractorSchemas(values, machine);
        this._licencePlate = values.licensePlate;
        this._machineTypeId = undefined; // TODO(PAVASALEVO-582): comentarios
        this._machineStateId = values.state ? MachineState.ACTIVE : MachineState.INACTIVE;
    }

    url() {
        return RouterUtils.generateRoute(ApiEndpoints.MACHINE_ID, { id: this._id });
    }

    body() {
        return {
            id: this._id,
            name: this._licencePlate,
            brand: this._brand,
            model: this._model,
            notes: this._description,
            company_id: this._companyId,
            contractors: this._contractors,
            machine_type_id: this._machineTypeId,
            machine_state_id: this._machineStateId,
        };
    }

    _parseContractorSchemas(values, machine) {
        const { contractorId, contractorSchema } = values;
        const nextSchemas = {};
        const nextMySchema = contractorSchema[0];
        const machineDocumentation = machine.documentation();

        machineDocumentation
            .schemas()
            .forEach((s) => {
                nextSchemas[s.contractorId()] = {
                    contractor_id: s.contractorId(),
                    document_schema_id: s.documentSchemaId(),
                };
            });

        if ( nextMySchema ) {
            nextSchemas[contractorId] = {
                contractor_id: contractorId,
                document_schema_id: nextMySchema.value,
            };
        } else {
            delete nextSchemas[contractorId];
        }

        return Object.values(nextSchemas);
    }
}



// WEBPACK FOOTER //
// ./src/app/my-outsources/machine/form/update/machine-update/MachineUpdateRequest.js